import {Component, Input, OnInit} from '@angular/core';
import {BranchMathValve} from "../branch-type-math-valve/ValveMathStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {sprintf} from "sprintf-js";
import {BranchFurtiValve} from "./ValveFurtiStruct";

@Component({
  selector: 'app-branch-type-furti-valve-component',
  templateUrl: './branch-type-furti-valve-component.component.html',
  styleUrls: ['./branch-type-furti-valve-component.component.css']
})
export class BranchTypeFurtiValveComponentComponent implements OnInit {
  @Input() branchFurtiValve: BranchFurtiValve | undefined;
  furtilizer: &VariableValue = new VariableValue();
  drain: &VariableValue = new VariableValue();


  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
      return "NaN";
    return sprintf("%5d", variable.val);
  }

  ngOnInit(): void {
    if(this.branchFurtiValve) {
      this.furtilizer     = this.variableDB.AddValueByReference(this.branchFurtiValve.furtilizer.variable.id);
      this.drain          = this.variableDB.AddValueByReference(this.branchFurtiValve.drain.variable.id);
    }
  }
}
